var _g, _g2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconLeftFarmers = function SvgIconLeftFarmers(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "60px",
    height: "20px",
    viewBox: "0 0 60 20",
    enableBackground: "new 0 0 60 20",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M49.554,18.965c-0.349,0-0.628-0.299-0.597-0.654c0.029-0.32,0.328-0.541,0.648-0.543 c4.26-0.027,7.716-3.502,7.716-7.767c0-4.267-3.456-7.739-7.716-7.768c-0.32-0.002-0.619-0.224-0.648-0.543 c-0.031-0.356,0.248-0.655,0.597-0.655c4.944,0,8.966,4.021,8.966,8.966C58.52,14.943,54.498,18.965,49.554,18.965z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M38.092,18.965c-0.35,0-0.629-0.299-0.596-0.654c0.028-0.32,0.326-0.541,0.647-0.543 c4.259-0.027,7.716-3.502,7.716-7.767c0-4.267-3.456-7.739-7.716-7.768c-0.321-0.002-0.619-0.224-0.647-0.543 c-0.033-0.356,0.246-0.655,0.596-0.655c4.943,0,8.966,4.021,8.966,8.966C47.058,14.943,43.035,18.965,38.092,18.965z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M25.004,18.965c-0.35,0-0.629-0.299-0.596-0.654c0.029-0.32,0.327-0.541,0.648-0.543 c4.26-0.027,7.715-3.502,7.715-7.767c0-4.267-3.456-7.739-7.715-7.768c-0.321-0.002-0.619-0.224-0.648-0.543 c-0.033-0.356,0.247-0.655,0.596-0.655c4.943,0,8.965,4.021,8.965,8.966C33.97,14.943,29.948,18.965,25.004,18.965z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M13.542,18.965c-0.35,0-0.628-0.299-0.596-0.654c0.029-0.32,0.327-0.541,0.648-0.543 c4.26-0.027,7.716-3.502,7.716-7.767c0-4.267-3.456-7.739-7.715-7.768c-0.321-0.002-0.619-0.224-0.648-0.543 c-0.032-0.356,0.247-0.655,0.596-0.655c4.944,0,8.966,4.021,8.966,8.966C22.508,14.943,18.486,18.965,13.542,18.965z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M2.08,18.965c-0.35,0-0.629-0.299-0.597-0.654c0.029-0.32,0.328-0.541,0.648-0.543 C6.391,17.74,9.848,14.266,9.848,10c0-4.267-3.456-7.739-7.716-7.768C1.811,2.231,1.513,2.009,1.483,1.69 C1.451,1.333,1.73,1.035,2.08,1.035c4.944,0,8.965,4.021,8.965,8.966C11.045,14.943,7.024,18.965,2.08,18.965z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLeftFarmers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-left-farmers.d230f77a.svg";
export { ForwardRef as ReactComponent };